var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2857 0H0.714286C0.319196 0 0 0.365625 0 0.818182V17.1818C0 17.6344 0.319196 18 0.714286 18H19.2857C19.6808 18 20 17.6344 20 17.1818V0.818182C20 0.365625 19.6808 0 19.2857 0ZM18.3929 2.83295V16.1591H1.60714V2.83295L0.991072 2.28324L1.8683 0.992045L2.82366 1.84347H17.1786L18.1339 0.992045L19.0112 2.28324L18.3929 2.83295ZM17.1786 1.84091L10 8.23295L2.82143 1.84091L1.86607 0.989489L0.988839 2.28068L1.60491 2.8304L9.22991 9.62131C9.44919 9.81644 9.71897 9.92237 9.99665 9.92237C10.2743 9.92237 10.5441 9.81644 10.7634 9.62131L18.3929 2.83295L19.0089 2.28324L18.1317 0.992045L17.1786 1.84091Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.5961673270bc6e7f43801010b08518f6.svg";
export { ForwardRef as ReactComponent };